import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft } from 'lucide-react';
import { AuthService } from '../services/authService';

export const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await AuthService.forgotPassword(email);
    } finally {
      // Always show the same confirmation regardless of outcome — the
      // backend responds generically to avoid revealing which emails exist.
      setSubmitting(false);
      setSent(true);
    }
  };

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center p-6">
      <div className="bg-white max-w-md w-full p-8 rounded-2xl shadow-lg border border-neutral-200">
        <div className="text-center mb-6">
          <div className="w-14 h-14 bg-primary/10 text-primary rounded-full flex items-center justify-center mx-auto mb-4">
            <Mail size={24} />
          </div>
          <h1 className="text-xl font-semibold text-neutral-800">¿Olvidaste tu contraseña?</h1>
          <p className="text-sm text-neutral-500 mt-2">
            Ingresa tu correo y te enviaremos instrucciones para restablecerla.
          </p>
        </div>

        {sent ? (
          <div className="bg-success/10 border border-success/20 text-success px-4 py-3 rounded-lg text-sm text-center">
            Si el correo está registrado, te enviamos instrucciones para restablecer tu contraseña.
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="forgot-email" className="block text-sm font-medium text-neutral-700 mb-1">
                Email
              </label>
              <input
                id="forgot-email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="tu.email@empresa.com"
                className="w-full p-3 border border-neutral-300 rounded-lg focus:ring-2 focus:ring-primary outline-none"
                required
              />
            </div>
            <button
              type="submit"
              disabled={submitting}
              className="w-full bg-primary text-white py-3 rounded-lg font-semibold hover:bg-[#002a5c] transition-colors disabled:opacity-60"
            >
              {submitting ? 'Enviando...' : 'Enviar instrucciones'}
            </button>
          </form>
        )}

        <Link to="/" className="mt-6 flex items-center justify-center gap-1.5 text-sm text-neutral-500 hover:text-primary transition-colors">
          <ArrowLeft size={14} /> Volver a iniciar sesión
        </Link>
      </div>
    </div>
  );
};
